import React from 'react';
import { Analytics } from '@vercel/analytics/react';
import { BrowserRouter, Link, Navigate, Route, Routes, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import StateBlock from './components/StateBlock';
import { ToastProvider } from './components/ToastProvider';
import { ConfirmProvider } from './components/ConfirmProvider';
import { useAuth } from './context/AuthContext';
import LandingPage from './pages/LandingPage';
import Register from './pages/Register';
import Login from './pages/Login';
import MinhasListas from './pages/MinhasListas';
import ListaDeCompras from './pages/ListaDeCompras';
import Perfil from './pages/Perfil';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated } = useAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    // Guarda o destino para voltar a ele depois do login.
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return children;
};

const GuestRoute = ({ children }) => {
  const { isAuthenticated } = useAuth();

  return isAuthenticated ? <Navigate to="/listas" replace /> : children;
};

const NotFound = () => (
  <div className="page">
    <StateBlock
      icon="bi-compass"
      title="Página não encontrada"
      description="O endereço acessado não existe ou foi movido."
    >
      <Link to="/" className="btn btn--primary">
        Voltar para o início
      </Link>
    </StateBlock>
  </div>
);

const App = () => (
  <BrowserRouter>
    <ToastProvider>
      <ConfirmProvider>
        <div className="app-shell">
          <a className="skip-link" href="#conteudo">
            Ir para o conteúdo
          </a>
          <Navbar />
          <main className="app-main" id="conteudo">
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route
                path="/register"
                element={
                  <GuestRoute>
                    <Register />
                  </GuestRoute>
                }
              />
              <Route
                path="/login"
                element={
                  <GuestRoute>
                    <Login />
                  </GuestRoute>
                }
              />
              <Route
                path="/listas"
                element={
                  <ProtectedRoute>
                    <MinhasListas />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/lista/:id"
                element={
                  <ProtectedRoute>
                    <ListaDeCompras />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/perfil"
                element={
                  <ProtectedRoute>
                    <Perfil />
                  </ProtectedRoute>
                }
              />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </main>
        </div>
      </ConfirmProvider>
    </ToastProvider>
    <Analytics />
  </BrowserRouter>
);

export default App;
